module.exports = __webpack_public_path__ + "wxMicroService/img/404.32e7d7dc.png";